<template>
    <div class="" v-title data-title="待办事项_试剂采购库存管理系统">
        <ZnBreadcrumb />
        <div class="main-content">
            <div class="btnLine">
            
            
             <el-select style="padding-right: 25px;"
                v-model="selectValue"
                @change="getDataList"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              
                <button class="cursorPointer" @click="clearRead">清空已读</button>
                <button class="cursorPointer" @click="readAll">全部标记为已读</button>
            </div>
            <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                prop="date"
                label="待办内容"
                width="500" >
                <template slot-scope="scope">
                 <div    v-if="scope.row.typeSubclass == '1' && scope.row.typeSubclass == '1'" @click="jump(scope.row)" class="poser">
                        <span class="point" v-if="!scope.row.readState"></span>
                        <span v-if="scope.row.admin === 2">您有<span class="numText">{{scope.row.taskNum}}</span>个试剂本日未归还</span>
                        <span v-else-if="scope.row.admin === 1">本日有<span class="numText">{{scope.row.taskNum}}</span>个试剂本日未归还</span>
                    </div>
                    <div    v-if="scope.row.typeSubclass === '2' && scope.row.type == '2' " @click="jump1(scope.row,1)" class="poser">
                        <span class="point" v-if="!scope.row.readState"></span>
                        <span v-if="scope.row.admin === 2">您有<span class="numText">{{scope.row.taskNum}}</span>个试剂转借申请成功通知</span>
                        <span v-else-if="scope.row.admin === 1">本日有<span class="numText">{{scope.row.taskNum}}</span>个试剂转借申请成功通知</span>
                    </div>
                     <div    v-if="scope.row.typeSubclass === '2'&& scope.row.type == '1' " @click="jump1(scope.row,2)" class="poser">
                        <span class="point" v-if="!scope.row.readState"></span>
                        <span v-if="scope.row.admin === 2">您有<span class="numText">{{scope.row.taskNum}}</span>个试剂收到转借申请</span>
                        <span v-else-if="scope.row.admin === 1">本日有<span class="numText">{{scope.row.taskNum}}</span>个试剂收到转借申请</span>
                    </div>

                    


                    <div    v-if="scope.row.type === '2'&& scope.row.typeSubclass == '4' " @click="jump2(scope.row)" class="poser">
                        <span class="point" v-if="!scope.row.readState"></span>
                        <span >您有<span class="numText">{{scope.row.taskNum}}</span>个订单供应商已确认!</span>
                    </div>
                     <div    v-if="scope.row.type === '1'&& scope.row.typeSubclass == '5' " @click="jump2(scope.row)" class="poser">
                        <span class="point" v-if="!scope.row.readState"></span>

                        <span  >您有1个订单：<span class="numText">{{scope.row.taskNum}}</span>供应商已发货!</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="gmtCreate"
                label="发送时间"
                width="500"
                >
                <template slot-scope="scope">
                    <span class="poser"  @click="jump(scope.row.id)">{{scope.row.gmtCreate}}</span>
                </template>


            </el-table-column>
            <el-table-column
                label="操作">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.readState" @click="delTask(scope.row.id)"
                    type="text"
                    size="middle"
                    >删除</el-button>
                    <div v-else>-</div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination
            :dataTotal="total"
            :totalpage="totalpage"
            :pagesize="pagesData.pageSize"
            @changePage="changePage"
            ></Pagination>
        </div>
    </div>
</template>

<script>
import { EventBus } from "../../config/event-bus.js";
export default {
    data(){
        return{
            tableData:[],
            total: 0,
            totalpage: 0,
            pagesData: {
                pageNum: 1,
                pageSize: 10,
                selectValue:null,
            },
            //用户类型 1管理员 2普通用户
            queryType:null,
              //状态下拉选择选项
      selectOptions: [
          {
          value: null,
          label: "全部",
        },
       {
          value: 2,
          label: "系统通知",
        },
        {
          value: 1,
          label: "待办工作",
        },
      ],
      selectValue: null,
        }
    },
    created() {
        const userInfo = localStorage.getItem('userInfo')
        const {userRole} = JSON.parse(userInfo)
        this.queryType = userRole == 1 ? 1 : 2
        this.getDataList();
    },
    methods:{
        //获取数据列表
        async getDataList(){
            const {pageNum,pageSize} = this.pagesData
            const res =  await this.$apiFetch.get('/lockerTask/queryTaskList/'+this.selectValue,{pageNum,pageSize})
            if(!res.data.code){
                this.tableData = res.data.list
                this.total = res.data.total
                this.totalpage = res.data.pages
            }
        },
        //清空已读
        async clearRead(){
            const res =  await this.$apiFetch.post('/lockerTask/removeTaskList',{queryType:this.queryType})
            if(!res.data.code){
                this.pagesData.pageNum = 1
                this.getDataList();
                 this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });
                
            }
        },
        //全部标记为已读
        async readAll(){
            const res =  await this.$apiFetch.post('/lockerTask/marksReadTask',{queryType:this.queryType})
            if(!res.data.code){
                 this.pagesData.pageNum = 1
                this.getDataList()

                  this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });
            }
        },
        //删除消息
        async delTask(id){
            const res =  await this.$apiFetch.post('/lockerTask/delTask',{queryType:this.queryType,id})
            if(!res.data.code){
                 this.pagesData.pageNum = 1
                 this.getDataList()

                  this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                     
                });
            }

        },
              //跳转
        async jump2(info){
                          //const {queryType} = this
            const {id} = info
            const res = await this.$apiFetch.post('/lockerTask/marksReadTaskById',{id})
            if(!res.data.code){
                let current = this.tableData.find(item=>item.id === id)
                current.readState = true
                    //普通用户跳到我的借用
                    this.$router.push('/myOrder?visitType=todos')
                
                  this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });
            }
        },
        //跳转
        async jump(info){
            //const {queryType} = this
            const {id} = info
            const res = await this.$apiFetch.post('/lockerTask/marksReadTaskById',{id})
            if(!res.data.code){
                let current = this.tableData.find(item=>item.id === id)
                current.readState = true
                if(info.admin === 1){
                    //管理员跳到柜机试剂管理
                    this.$router.push('/ReagentRun?visitType=manager')

                    this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });
                }else if(info.admin === 2){
                    //普通用户跳到我的借用
                    this.$router.push('/myBorrow?visitType=todos')

                    this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });

                }
            }
        },
               //跳转
        async jump1(info,admin){
            //const {queryType} = this
            const {id} = info
            const res = await this.$apiFetch.post('/lockerTask/marksReadTaskById',{id})
            if(!res.data.code){
                let current = this.tableData.find(item=>item.id === id)
                
                current.readState = true
                    //普通用户跳到我的借用
                    if(admin == 1){
                        this.$router.push('/myBorrow?visitType=4')
                    }else {
                        this.$router.push('/myBorrow?visitType=5') 
                    }
                    
                this.$apiFetch.get('/lockerTask/queryTaskListNumber/'+this.selectValue).then((res) => {
                    EventBus.$emit('showTodoNum',res.data.total);
                  });

                
            }
        },
         
        changePage(data) {
            this.pagesData.pageNum = data;
            this.getDataList();
        }
    }
}
</script>

<style lang="less" scoped> 
    .main-content{
        padding: 20px;
    }
    .btnLine{
        display: flex;
        margin-bottom: 20px;

        button{
            width: 120px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            font-size: 13px;
            color: #666;
            border-radius: 4px;
            border: 1px solid #999999;
            margin-right:10px ;
            background-color: #fff;
        }
    }

    /deep/.el-table th{
        background: #F8FAFC;
    }

    .numText{
        color: #478AFF;
    }

    .point {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #FA8C16;
        margin-right: 23px;
    }

    .poser{
        cursor: pointer;
    }

</style>